window.do_ajax = function(action, data, successCb, errorCb) {
    // console.trace('do_ajax', action, data);

    let array;
    array = null;
    array = data || {};
    array['ajax'] = action;
    $.ajax({
        url: '/database/ajax.php',
        method: 'post',
        data: array,
        success: function(data) {
            if (successCb) {
                return successCb(data);
            }
        },
        error: function(error) {
            if (errorCb) {
                return errorCb(data);
            }
        }
    });
}

window.session_ajax = function(data, successCb, errorCb) {
    // console.trace('session_ajax', data);

    $.ajax({
        url: '/assets/includes/session.php',
        method: 'post',
        data: data,
        success: function(data) {
            if (successCb) {
                return successCb(data);
            }
        },
        error: function(error) {
            if (errorCb) {
                return errorCb(data);
            }
        }
    });
}

window.record_timestamp = function(type) {
    $.ajax({
        url: '/record-user-timestamp',
        method: 'post',
        data: {
            type: type,
        }
    });
}
